// Application entry point.
//
// Retool mounted App.tsx itself and supplied the router and the session. Both
// are explicit here: BrowserRouter wraps the app (App.tsx renders <Routes>
// without a router of its own), and the tree waits for the session check so
// App.tsx can keep assuming a signed-in user.

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import App from './App'
import LoginPage from './LoginPage'
import { AuthProvider, useAuth } from './auth'
import './index.css'

function Gate() {
  const { user, loading } = useAuth()

  if (loading) {
    // Deliberately blank: a spinner here flashes on every navigation to the app.
    return <div className="min-h-dvh bg-background" />
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
      <Route
        path="*"
        element={user ? <App /> : <Navigate to={`/login?next=${encodeURIComponent(window.location.pathname)}`} replace />}
      />
    </Routes>
  )
}

const container = document.getElementById('root')
if (!container) throw new Error('index.html is missing <div id="root">')

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <Gate />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
)
